"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _icons = require("../../icons");
var _indicatorButton = require("./indicator-button.css");
var _IndicatorButtonTooltip = _interopRequireDefault(require("../../IndicatorButtonTooltip"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const IndicatorButton = ({
  testId,
  tooltip,
  icon,
  showSpinner,
  highlighted,
  disabled,
  clickable = true,
  onClick,
  onMouseEnter,
  onMouseLeave
}) => {
  const [tooltipVisible, setTooltipVisible] = (0, _react.useState)(tooltip === null || tooltip === void 0 ? void 0 : tooltip.visible);
  const [tooltipIsRemoved, setTooltipIsRemoved] = (0, _react.useState)(!(tooltip !== null && tooltip !== void 0 && tooltip.visible));
  const onButtonMouseEnter = () => {
    if (!disabled && (tooltip === null || tooltip === void 0 ? void 0 : tooltip.trigger) === `hover`) {
      setTooltipIsRemoved(false);
      setTooltipVisible(true);
      onMouseEnter === null || onMouseEnter === void 0 ? void 0 : onMouseEnter();
    }
  };
  const onButtonMouseLeave = () => {
    if (!disabled && (tooltip === null || tooltip === void 0 ? void 0 : tooltip.trigger) === `hover`) {
      setTooltipVisible(false);
      onMouseLeave === null || onMouseLeave === void 0 ? void 0 : onMouseLeave();
    }
  };
  const onButtonClick = () => {
    if (!disabled && (tooltip === null || tooltip === void 0 ? void 0 : tooltip.trigger) === `click`) {
      setTooltipIsRemoved(prop => !prop);
      setTooltipVisible(prop => !prop);
    }
    onClick === null || onClick === void 0 ? void 0 : onClick();
  };
  const onTooltipDisappear = () => {
    var _tooltip$onDisappear;
    setTooltipIsRemoved(true);
    tooltip === null || tooltip === void 0 ? void 0 : (_tooltip$onDisappear = tooltip.onDisappear) === null || _tooltip$onDisappear === void 0 ? void 0 : _tooltip$onDisappear.call(tooltip);
  };
  (0, _react.useEffect)(() => {
    setTooltipVisible(tooltip === null || tooltip === void 0 ? void 0 : tooltip.visible);
    if (tooltip !== null && tooltip !== void 0 && tooltip.visible) {
      setTooltipIsRemoved(false);
    }
  }, [tooltip === null || tooltip === void 0 ? void 0 : tooltip.visible]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _indicatorButton.wrapperStyle,
    "data-testid": testId,
    onMouseEnter: onButtonMouseEnter,
    onMouseLeave: onButtonMouseLeave
  }, /*#__PURE__*/_react.default.createElement("button", {
    disabled: disabled,
    onClick: onButtonClick,
    className: _indicatorButton.buttonStyle[highlighted ? `highlighted` : clickable ? `clickable` : `default`]
  }, icon, showSpinner && /*#__PURE__*/_react.default.createElement("span", {
    className: _indicatorButton.spinnerStyle
  }, _icons.spinnerIcon)), tooltip && !!tooltip.content && !tooltipIsRemoved && /*#__PURE__*/_react.default.createElement(_IndicatorButtonTooltip.default, (0, _extends2.default)({}, tooltip, {
    visible: tooltipVisible,
    onDisappear: onTooltipDisappear
  })));
};
var _default = IndicatorButton;
exports.default = _default;